import Icon from '../components/Icon.vue'

Icon.register({
  'cart-plus': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M504.7 320H211.6L218.1 352H486.5C501.9 352 513.4 366.3 509.9 381.3L504.4 405.6C523.1 414.7 536 433.8 536 456 536 487.2 510.5 512.4 479.2 512 449.4 511.6 424.8 487.4 424 457.5 423.6 441.3 430.1 426.5 440.8 416H231.2C241.6 426.2 248 440.3 248 456 248 487.8 221.5 513.4 189.3 511.9 160.8 510.6 137.6 487.6 136.1 459 134.9 437 146.5 417.6 164.1 407.4L93.9 64H24C10.7 64 0 53.3 0 40V24C0 10.7 10.7 0 24 0H126.5C137.9 0 147.8 8 150 19.2L159.2 64H552C567.4 64 578.8 78.3 575.4 93.3L528.1 301.3C525.6 312.2 515.9 320 504.7 320zM408 168H360V128C360 119.2 352.8 112 344 112H328C319.2 112 312 119.2 312 128V168H264C255.2 168 248 175.2 248 184V200C248 208.8 255.2 216 264 216H312V256C312 264.8 319.2 272 328 272H344C352.8 272 360 264.8 360 256V216H408C416.8 216 424 208.8 424 200V184C424 175.2 416.8 168 408 168z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cart-plus.js
// module id = CO2B
// module chunks = 144